export function GetLocalStorage(name: string): string | undefined {
    let s = undefined;
    if (typeof (Storage) !== "undefined") {
        const value = localStorage.getItem(name) || undefined;
        if (value !== undefined && value !== "") s = value;
        else localStorage.removeItem(name);
    }
    return s;
}

export function SetLocalStorage(name: string, value: string | undefined): string | undefined {
    let predValue = undefined;
    if (typeof (Storage) !== "undefined") {
        predValue = localStorage.getItem(name) || undefined;
        if (value !== undefined && value !== "") {
            if (predValue !== value) localStorage.setItem(name, value);
        } else {
            localStorage.removeItem(name);
        }
    }
    return predValue;
}
